import { useState, useEffect } from "react";
import { Paper, Stack, Loader, Text, Center, Button, Container } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { api } from "../../api/api";

export const PDFDocumentPreview = ({ pdfUrl, onClose }: { pdfUrl: string | null, onClose: () => void }) => {
	const [documentBlob, setDocumentBlob] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	useEffect(() => {
		if (pdfUrl) {
			loadPdf();
		}
	}, [pdfUrl]);

	const loadPdf = async () => {
		if (!pdfUrl) return;
		setIsLoading(true);
		const response = await api.get(pdfUrl, {
			responseType: 'arraybuffer',
			headers: {
				'Content-Type': 'application/json'
			}
		});

		const type = response.headers['content-type']
		const blob = new Blob([response.data], { type: type });
		const blobURL = URL.createObjectURL(blob);
		// window.open(blobURL);
		setDocumentBlob(blobURL);
		setIsLoading(false);
	}

	const handleIframeLoad = () => {
		setIsLoading(false);
	};

	const handleClose = () => {
		setDocumentBlob(null);
		onClose();
	};

	if (!pdfUrl) return null;

	return <>
		{isLoading &&
			<Paper withBorder p={0} radius="lg" mb="lg" style={{ overflow: 'hidden' }} mih={400}>
				<Stack gap="xs" justify="center" align="center" style={{ height: 'calc(100vh - 340px)' }}>
				
					<Loader size="sm" mt="lg" />
					<Text c="dimmed">Loading Preview</Text>
				
				</Stack>
			</Paper>
		}
		{documentBlob && <>
			<Stack gap="sm" justify="center" align="center" mb="lg">
				<Button variant="outline" radius="lg" onClick={handleClose} leftSection={<IconX />}>Close Preview</Button>
				<iframe src={documentBlob} onLoad={handleIframeLoad} style={{ width: '100%', height: "calc(100vh - 340px)", border: '0px', borderRadius: '10px', overflow: 'hidden' }} />
			</Stack>
		</>}
	</>
}
